module.exports = __webpack_public_path__ + "img/person-to-portal.90ee1453.svg";